import Message from "./Message";

interface IChat {
  id: string;
  name?: string;
  createdAt?: Date;
  messages?: Message[];
}

export default class Chat {
  private _id: string;
  private _name: string;
  private _createdAt: Date;
  private _messages: Message[];

  constructor(data: IChat) {
    this._id = data.id;
    this._name = data.name || "";
    this._createdAt = data.createdAt || new Date(Date.now());
    this._messages = data.messages || [];
  }

  get id() {
    return this._id;
  }

  get name() {
    return this._name;
  }

  get createdAt() {
    return this._createdAt;
  }

  get messages() {
    return this._messages;
  }

  set name(name: string) {
    this._name = name;
  }
}